export enum MensagemTipoEnum{
  CLIENTE = 'CLIENTE',
	SISTEMA = 'SISTEMA',
}
